import React from "react";
import { connect } from "react-redux";
import "./FelixSignUp.scss";

const CommissionJunction = (props) => {
  window.location.href="https://cfdhero.com"
  return (
    <></>
  );
};

export default connect(null, {  })(CommissionJunction);
